var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBellWideinline = function SvgBellWideinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.9 17.25c-1.01 0-1.833-.841-1.833-1.875V8.25C19.067 3.7 15.448 0 11 0S2.933 3.7 2.933 8.25v7.125c0 1.034-.822 1.875-1.833 1.875-.607 0-1.1.504-1.1 1.125S.493 19.5 1.1 19.5h19.8c.607 0 1.1-.504 1.1-1.125s-.493-1.125-1.1-1.125M12.758 21H9.24a.73.73 0 0 0-.57.277.76.76 0 0 0-.147.627C8.776 23.138 9.796 24 11 24s2.223-.863 2.477-2.096a.76.76 0 0 0-.148-.626.73.73 0 0 0-.57-.278"
  })));
};
export default SvgBellWideinline;